// @ts-nocheck
import { createAction, createAsyncAction } from '../../../core/store/actionCreators';
import {
  CREATE_PRODUCT_CHANGE,
  DELETE_PRODUCT_CHANGE,
  FETCH_PRODUCT,
  FETCH_PRODUCTS,
  FETCH_PRODUCT_CHANGE,
  FETCH_PRODUCT_CHANGE_NEXT,
  SELECT_PRODUCT,
  DESELECT_PRODUCT,
} from './productActionTypes';
import ProductService from '../services/ProductService';

export const fetchProducts = createAsyncAction(
  FETCH_PRODUCTS,
  async (filterParams) => {
    const { data } = await ProductService.fetchProducts(filterParams);
    return data;
  }
);

export const fetchProduct = createAsyncAction(FETCH_PRODUCT, async productId => {
  const { data } = await ProductService.fetchProduct(productId);
  return data;
});

export const selectProduct = createAction(SELECT_PRODUCT, async productId => {
  return productId;
});

export const deselectProduct = createAction(DESELECT_PRODUCT);

export const createProductChange = createAsyncAction(
  CREATE_PRODUCT_CHANGE,
  async productChangeData => {
    const { data } = await ProductService.createProductChange(productChangeData);
    return data;
});

export const fetchProductChange = createAsyncAction(
  FETCH_PRODUCT_CHANGE, 
  async (filterParams, sortParams, page, limit) => {
    try {
      const { data } = await ProductService.fetchProductChange(filterParams, sortParams, page, limit);
      return data;
    } catch (e) {
      console.log(e);
      return {
        productChanges: [],
        pageCount: 1,
        pageEntries: 0,
        totalCount: 0
      };
    }
});

export const fetchNextProductChange = createAsyncAction(
  FETCH_PRODUCT_CHANGE_NEXT, 
  async (productId) => {
    try {
      const { data } = await ProductService.fetchProductChange({
          productIds: [ productId ],
          states: [ 'PENDING' ]
        },
        { sortBy: 'effective_date', sortOrder: 'asc' },
        1,
        1
      );
      return data;
    } catch (e) {
      console.log(e);
      return {
        productChanges: [],
        pageCount: 1,
        pageEntries: 0,
        totalCount: 0
      };
    }
});

export const deleteProductChange = createAsyncAction(DELETE_PRODUCT_CHANGE, async (productChangeId) => {
  const { data } = await ProductService.deleteProductChange(productChangeId);
  return data;
});
